import { TrashCan } from "@carbon/icons-react";
import {
  CopyButton,
  SwitchAppIconButton,
  SwitchAppInlineLoadingIcon,
} from "..";
import { useMerchantApiMutation } from "../../hooks";
import { IViewMerchantDedicatedTopUpAccount } from "../../interfaces-and-types";

export const TopUpAccount = (acc: IViewMerchantDedicatedTopUpAccount) => {
  const {
    isSuccess: isSuccessDeallocateTopUpAccountById,
    isLoading: isLoadingDeallocateTopUpAccountById,
    isError: isErrorDeallocateTopUpAccountById,
    mutate: deallocateTopUpAccountById,
  } = useMerchantApiMutation<void, void>(
    "deallocateDedicatedTopUpAccountById",
    ["getMerchantDedicatedTopUpAccounts"],
    {},
    (templateUrl) => templateUrl.replace("{id}", acc.id)
  ).useDeleteMutation;

  const {
    isSuccess: isSuccessRevalidateTopUpAccountById,
    isLoading: isLoadingRevalidateTopUpAccountById,
    isError: isErrorRevalidateTopUpAccountById,
    mutate: revalidateTopUpAccountById, // confirms acc is still existing & in the saved account name else deallocates it
  } = useMerchantApiMutation<void, void>(
    "revalidateDedicatedTopUpAccountById",
    ["getMerchantDedicatedTopUpAccounts"],
    {},
    (templateUrl) => templateUrl.replace("{id}", acc.id)
  ).usePostMutation;

  const handleDeallocateTopUpAccount = () => {
    if (
      window.confirm(
        "Are you sure you want to deallocate this account? You will NOT be able to recover the ACCOUNT NUMBER again from the same bank! (NOTE: you should also REMOVE it from your beneficiaries list in all bank apps)"
      )
    )
      deallocateTopUpAccountById();
  };

  return (
    <>
      <div className="deallocate-account-button--container justify-content--center align-items--center ">
        <SwitchAppIconButton
          size="sm"
          kind="danger"
          onClick={handleDeallocateTopUpAccount}
          className="deallocate-account--button"
          title="Deallocate Account"
          disabled={isLoadingDeallocateTopUpAccountById}
        >
          {isLoadingDeallocateTopUpAccountById ? (
            <SwitchAppInlineLoadingIcon />
          ) : null}
          <TrashCan
            className="text-danger"
            size="20"
            // style={{ width: "30px", height: "30px" }}
          />
        </SwitchAppIconButton>
      </div>

      <div className="flex-container justify-content--center mb-3">
        <strong className="bank-name switchapp-small font-ctm--black fixed-length-display">
          {acc.bank_name.toUpperCase()}
        </strong>
      </div>
      <div className="flex-container justify-content--center mb-5">
        <div className="flex-container justify-content--start align-items--center no-wrap">
          <strong className="account-number fixed-length-display font-ctm--bold">
            {acc.account_number}
          </strong>
          <div className="ml-3">
            <CopyButton
              name="copy-account-button"
              stringToCopy={acc.account_number}
              iconDescription="copy account number"
              className="copy-btn"
            />
          </div>
        </div>
      </div>
      <div className="flex-container align-items--center col">
        <span className="switchapp-small">Account Name: </span>
        <strong className="account-name fixed-length-display font-ctm--bold text--center">
          {acc.account_name.toUpperCase()}
        </strong>
      </div>
    </>
  );
};
